// Der Terminologiebereich: die Liste aller Begriffe, ihre Filter und die schrittweise Übersetzung.
// Getrennt von `terminology.ts` (dem Editor) — beide Slices dürfen keinen Schlüssel teilen.
export default {
	terminologyArea: {
		count: "{shown} von {total} Eintrag | {shown} von {total} Einträgen",
		search: {
			placeholder: "Begriffe, Synonyme und Beschreibungen durchsuchen…",
		},
		scope: {
			label: "Suchen in",
			term: "Begriffen",
			synonyms: "Synonymen",
			description: "Beschreibungen",
		},
		sort: {
			name: "Name",
			gaps: "Lücken",
		},
		filters: {
			missing: "Fehlt in",
			missingField: "Was fehlt",
			fields: {
				term: "Begriff",
				description: "Beschreibung",
			},
			anyLanguage: "Nicht gefiltert",
			has: "Hat einen Begriff in",
			status: {
				label: "Prüfung",
				all: "Alle",
				needsReview: "Zu prüfen",
				verified: "Geprüft",
			},
			origin: {
				label: "Anzeigen",
				own: "Dieses Projekt",
				withDependencies: "Mit Abhängigkeiten",
				overridesOnly: "Nur eigene Formulierungen",
			},
			clear: "Filter zurücksetzen",
		},
		columns: {
			label: "Begriff",
			origin: "Herkunft",
		},
		origin: {
			local: "Dieses Projekt",
			override: "Eigene Formulierung für „{alias}“",
			dependency: "Aus „{alias}“",
		},
		showMore: "{count} weitere anzeigen",
		loadFailed: "Die Terminologie konnte nicht geladen werden.",
		empty: {
			title: "Noch keine Terminologie",
			hint: "Begriffe entstehen, wenn Sie im Modell etwas benennen — ein Datenobjekt, ein Attribut, einen Typ. Hier gibt es nichts anzulegen.",
		},
		noResults: {
			title: "Keine passenden Einträge",
			hint: "Ändern Sie die Suche oder setzen Sie die Filter zurück.",
		},
		translate: {
			action: "Schrittweise übersetzen ({count})",
			nothing: "In dieser Liste gibt es nichts mehr zu übersetzen",
			title: "Schrittweise übersetzen",
			note: "Gehen Sie die Einträge durch, denen noch eine Übersetzung fehlt. Jeder Vorschlag wird erst gespeichert, nachdem Sie ihn geprüft haben.",
			target: "Übersetzen nach",
			progressLabel: "Fortschritt der Übersetzung",
			progress: "{position} / {total}",
			source: "Übersetzen aus",
			suggesting: "Übersetzung wird vorgeschlagen…",
			gatedNote:
				"Öffnen Sie diesen Eintrag im Editor, schreiben Sie eine Beschreibung und markieren Sie sie als geprüft, um Vorschläge freizuschalten. Die Übersetzung können Sie trotzdem selbst eintippen.",
			suggestAgain: "Erneut vorschlagen",
			back: "Zurück",
			skip: "Überspringen",
			saveNext: "Speichern & weiter",
			shortcut: "{keys}Enter speichert",
			noSourceLeft:
				"{count} Eintrag hat keinen Ausgangstext zum Übersetzen | {count} Einträge haben keinen Ausgangstext zum Übersetzen",
			finished: {
				title: "Alles erledigt",
				skippedTitle: "Ende der Liste",
				nothingTitle: "Nichts zu übersetzen",
				nothing:
					"In dieser Liste fehlt bei keinem Eintrag ein Begriff in {language}, der sich aus einer anderen Sprache übersetzen ließe.",
				translated: "Übersetzt: {count}",
				skipped: "Übersprungen: {count}",
				reviewSkipped: "Übersprungene prüfen ({count})",
			},
		},
	},
};
